import { aget, aFormPost } from '@/service'

//  发送短信验证码
export const getSendSmsCode = (params: any) => {
  return aget('/tztapi/authManager/sendSmsCode', params)
}
// 短信验证码注册
export const postSmsRegister = (params: any) => {
  return aFormPost('/tztapi/smsregister', params)
}

// 短信验证码登录
export const postSmslogin = (params: any) => {
  return aFormPost('/tztapi/smslogin', params)
}

// 密码登录
export const postLogin = (params: any) => {
  return aFormPost('/tztapi/login', params)
}

// 申请投资账户开户
export const postCreateInvestAccount = (params: any) => {
  return aFormPost('/tztapi/account/accountManager/createInvestAccount', params, { _loading: true })
}

// 查询开户资料类型列表
export const getAllProfileTypes = (params: any, cb?: any) => {
  return aget('/tztapi/account/accountManager/getAllProfileTypes', params)
}

// 上传投资账户开户资料文件
export const postUploadProfile = (params: any, cb?: any) => {
  return aFormPost('/tztapi/account/accountManager/uploadProfile', params, { timeout: 600000 }, cb)
}

// 删除投资账户开户资料
export const postDeleteProfile = (params: any) => {
  return aFormPost('/tztapi/account/accountManager/deleteProfile', params)
}

// 提交投资账户开户
export const postSubmitInvestAccount = (params: any) => {
  return aFormPost('/tztapi/account/accountManager/submitInvestAccount', params)
}

// 静默登录
export const postSilentlogin = (params: any) => {
  return aFormPost('/tztapi/silentlogin', params)
}

// 获取用户权限
export const getUserPermissions = (params?: any) => {
  return aget('/tztapi/authManager/getClassifiedPermissionsByUserId', params)
}

// 查询管理员账户名下的投资账户(有效机构户)
export const getOrgInvestAccounts = (params?: any) => {
  return aget('/tztapi/account/accountManager/getOrgInvestAccounts', params)
}
